import { render } from "./ChoixCoureurView.vue?vue&type=template&id=2aab3ed2"
import script from "./ChoixCoureurView.vue?vue&type=script&lang=js"
export * from "./ChoixCoureurView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__